import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DataEntryForm from "../../Forms/DataEntryForm/DataEntryForm";
import {
  IAppRouteLocation,
  IReport,
  IWorkflowItemStep
} from "../../../common/sharedTypes";
import {
  saveCheckers,
  loadImage,
  getFrontSheet
} from "./redux-objects/actions";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import { Button, Row, Col, Form } from "react-bootstrap";
import * as documentDownloadService from "../../../services/documentDownloadService";
import { UserInfo } from "../../Login/common/defaults";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import * as urls from "../../shared/urls";
import { toast } from "react-toastify";
import NotificationTemplateSelector from "../../NotificationTemplate/NotificationTemplateSelector";
import * as optionIds from "../../shared/optionIds";
import CommentsButton from "../../Comments/CommentsButton";
import CorrespondenceButton from "../../Correspondence/CorrespondenceButton";
import "./assets/checkers.scss";
import { confirm } from "./ConfirmationDialog";
import InfoButtonBar from "../common/InfoButtonBar";
import { showLoadingWithMessage } from "../../Application/redux-objects/actions";
import CreateFrontSheetButton from "../../CreateFrontSheetButton/CreateFrontSheetButton";

enum ServiceEndPoints {
  CompletePaperCheckers = "CompletePaperCheckers",
  GetPaperPdf = "GetPaperPdf"
}

export interface ICheckersActionProps {
  saveCheckers?: (
    itemStep: IWorkflowItemStep,
    data: any,
    complete: boolean,
    assignNext: boolean
  ) => Promise<void>;
  loadImage?: (documentId: string, forceNewWindow: boolean) => Promise<void>;
  getFrontSheet?: (reportId: number, forceNewWindow: boolean) => Promise<void>;
}

interface ICheckersStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  spdCheckbox: boolean;
  spdDisabled: boolean;
  workZoneCheckbox: boolean;
  workZoneDisabled: boolean;
  showLoadingWithMessage: (show: boolean, message?: string) => void;
}

interface ICheckersProps extends ICheckersActionProps, ICheckersStateProps {}

interface ICheckersState {
    data: any;
    reportData: IReport;
    formIsValid: boolean;
    spdCheckbox: boolean;
    spdDisabled: boolean;
    workZoneCheckbox: boolean;
    workZoneDisabled: boolean;
    openWorkflowItemStep?: IWorkflowItemStep;
    isCompleting: boolean;
    validationErrors: Array<any>;
}

class Checkers extends React.Component<ICheckersProps, ICheckersState> {
  constructor(props: ICheckersProps) {
    super(props);

    this.state = {
      data: null,
      reportData: this.props.openWorkflowItemStep.workflowItem.report,
      spdCheckbox: false,
      spdDisabled: false,
      workZoneCheckbox: false,
      workZoneDisabled: false,
      formIsValid: false,
      openWorkflowItemStep: this.props.openWorkflowItemStep,
      isCompleting: false,
      validationErrors: []
    };
  }

  private workflowController: string = "Workflow";
  checkersForm = null;
  backgroundSave;
  saving = false;
  dmvProcessing = false;
  componentIsMounted = false;

    private crashKey: any;

    private refreshFormValidity = async () => {
        if (!this.checkersForm) return false;

        if (this.checkersForm.getValidationErrorsAfterFlush) {
            const errors = await this.checkersForm.getValidationErrorsAfterFlush();
            const formIsValid = !errors.some((error) => error.type === "error");
            this.setState({ formIsValid, validationErrors: errors.filter((error) => error.type === "error") });
            return formIsValid;
        }

        if (this.checkersForm.isFormValidAfterFlush) {
            const valid = await this.checkersForm.isFormValidAfterFlush();
            this.setState({ formIsValid: valid });
            return valid;
        }

        const valid = this.checkersForm.isFormValid ? this.checkersForm.isFormValid() : false;
        this.setState({ formIsValid: valid });
        return valid;
    };

    private getSafeFormData = async () => {
        if (!this.checkersForm) return null;

        if (this.checkersForm.getLatestFormData) {
            return await this.checkersForm.getLatestFormData();
        }

        return this.checkersForm.getFormData();
    };

    private getApiErrorMessage = (err: any, fallback: string) => {
        return err?.data?.message || err?.message || fallback;
    };

  loadWorkflowItemStep = () => {
    if (!this.state.openWorkflowItemStep) {
      this.props.history.push("/Checkers");
      return;
    }

    this.getCheckersJsonData(this.state.openWorkflowItemStep);
    this.initializeCheckboxes(this.state.openWorkflowItemStep);

    let reportId = this.state.openWorkflowItemStep?.workflowItem?.reportId;
    if (reportId && reportId != 0) {
      this.getFrontSheet(false);
      this.viewAllDocuments(reportId);
    } else {
      console.log("no reportId?", this.state.openWorkflowItemStep);
    }
  };

  initializeCheckboxes = (openWorkflowItemStep: IWorkflowItemStep) => {
    const hasStatePropertyDamage =
      openWorkflowItemStep.workflowItem.report.keywords.propertyDamageIndicator?.toLocaleLowerCase() ==
      "yes";
    const isWorkzone =
      openWorkflowItemStep.workflowItem.report.keywords.workZoneIndicator?.toLocaleLowerCase() ==
      "yes";
    this.setState({
      spdCheckbox: hasStatePropertyDamage,
      spdDisabled: hasStatePropertyDamage,
      workZoneCheckbox: isWorkzone,
      workZoneDisabled: isWorkzone
    });
  };

  componentDidMount() {
    this.componentIsMounted = true;

    if (!this.backgroundSave) {
      this.backgroundSave = setInterval(() => {
        if (
          this.state.openWorkflowItemStep &&
          !this.saving &&
          !this.dmvProcessing
        )
          this.handleSave(null, false, false, false);
      }, 30000);
    }

    this.loadWorkflowItemStep();
  }

  viewAllDocuments = (reportId: number) => {
    const url = `/DocumentViewer?r=${reportId}&dbToSearch=${"private"}`;
    window.open(url, "_blank", "width=1300,height=900");
  };

  handleOpenPdf = () => {
    documentDownloadService
      .openOnBaseImage(
        null,
        this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId
      )
      .then();
  };

  setSpdCheckbox = () => {
    this.setState({ spdCheckbox: !this.state.spdCheckbox });
    this.setStatePropertyDamage();
  };

  setStatePropertyDamage = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(
        urls.SAVE_STATE_PROPERTY_DAMAGE +
          "?workflowItemStepId=" +
          this.state.openWorkflowItemStep.id,
        {
          ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
          propertyDamageIndicator: this.state.spdCheckbox
        }
      ).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  setWorkZoneCheckbox = () => {
    this.setState({
      workZoneCheckbox: !this.state.workZoneCheckbox,
      workZoneDisabled: true
    });
    this.setWorkZone();
  };

  setWorkZone = () => {
    if (this.state.openWorkflowItemStep.workflowItem.report.keywords) {
      Api.post(urls.SAVE_WORK_ZONE_INDICATOR, {
        ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
        workZoneIndicator: this.state.workZoneCheckbox
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
        }
      });
    }
  };

  loadImage = (forceNewWindow: boolean) => {
    this.props
      .loadImage(
        this.state.openWorkflowItemStep.workflowItem.report.keywords.documentId,
        forceNewWindow
      )
      .then();
  };

  getFrontSheet = (forceNewWindow: boolean) => {
    this.props
      .getFrontSheet(
        this.state.openWorkflowItemStep.workflowItem.report.id,
        forceNewWindow
      )
      .then();
  };

  getCheckersJsonData = (openWorkflowItemStep: IWorkflowItemStep) => {
    let id;
    if (openWorkflowItemStep != null) {
      id = { id: openWorkflowItemStep.workflowItemId.toString() };
      this.crashKey =
        openWorkflowItemStep.workflowItem.report.keywords &&
        openWorkflowItemStep.workflowItem.report.keywords.crashKey
          ? openWorkflowItemStep.workflowItem.report.keywords.crashKey.toString()
          : "0";
    } else {
      id = "0";
      this.crashKey = "0";
    }

    if (this.crashKey == null) {
      this.crashKey = "No Crash Key Available";
    }

    Api.post(urls.GET_REPORT_VALIDATION_JSON, JSON.stringify(id)).then(
      (response: ApiResponse<any>) => {
        // If response.data comes back as null, tell the user no draft report exists yet, and to save the report before entering data into checkers
        if (response.ok) {
          if(response.data){
            this.setState({ data: response.data || {} });
            } else {
              toast.info("No draft report data available. Please save the report before entering data into Checkers.");
            }
          }
        else {
          console.error(response.originalError);
          this.setState({ data: null });
        }
        return response.data;
      }
    );
  };

async handleComplete(
  event: React.MouseEvent<HTMLElement>,
  assignNext: boolean,
  complete: boolean,
  continueNavigation: boolean = true,
  manualSave: boolean = false
) {
    if (this.state.isCompleting) {
        return;
    }

    this.setState({ isCompleting: true });
    this.dmvProcessing = true;

    const isValidNow = await this.refreshFormValidity();
    if (!isValidNow) {
        toast.error("Please correct required fields before completing.");
        this.dmvProcessing = false;
        this.setState({ isCompleting: false });
        return;
    }

    const formData = await this.getSafeFormData();
    if (!formData) {
        this.dmvProcessing = false;
        this.setState({ isCompleting: false });
        return;
    }

  const routeToDmvResult = await confirm("Route to DMV?", {
    yesText: "Yes",
    noText: "No",
    cancelText: "Cancel"
  });

  if (routeToDmvResult === "cancel") {
    this.dmvProcessing = false;
    this.setState({ isCompleting: false });
    return;
  }

  // Capture everything needed BEFORE navigation/unmount
  if (!this.checkersForm) {
    this.dmvProcessing = false;
    this.setState({ isCompleting: false });
    return;
  }

  const step = this.state.openWorkflowItemStep;
  

  if (formData.data?.DateOfCrash?.trim() === "") {
    this.dmvProcessing = false;
    this.setState({ isCompleting: false });
    return;
  }

  const toastId = toast.success(
    routeToDmvResult === "yes"
      ? "Updating keywords, uploading front sheet, and routing to DMV..."
      : "Updating keywords and uploading front sheet..."
  );

  (async () => {
    try {
      if (routeToDmvResult === "yes") {
        await this.setRouteToDmvFlag(true);
      }

      await this.props.saveCheckers(step, formData, complete, assignNext);

      toast.update(toastId, {
        render: "Completed successfully.",
        type: "success",
      
        autoClose: 3000
      });
    } catch (err) {
      const message = this.getApiErrorMessage(err, "Failed to complete request.");
      if (err?.status !== 400) {
        console.error(err);
      }
      toast.update(toastId, {
        render: message,
        type: "error",
        autoClose: 5000
      });
    } finally {
        this.dmvProcessing = false;
        if (this.componentIsMounted) {
            this.setState({ isCompleting: false });
        }
    }
  })();

  if (continueNavigation) {
    this.props.history.push("/Checkers");
  }
}

async handleSave(
  event: React.MouseEvent<HTMLElement>,
  assignNext: boolean,
  complete: boolean,
  continueNavigation: boolean = true,
  manualSave: boolean = false
) {
  if (!this.checkersForm) return;

  const formData = this.checkersForm.getFormData();
  if (formData.data?.DateOfCrash?.trim() === "") return;

  this.saving = true;

  try {
    await this.props.saveCheckers(
      this.state.openWorkflowItemStep,
      formData,
      complete,
      assignNext
    );

    if (continueNavigation) {
      if (assignNext) {
        this.setState(
          { openWorkflowItemStep: this.props.openWorkflowItemStep },
          () => this.loadWorkflowItemStep()
        );
      } else {
        this.props.history.push("/Checkers");
      }
    } else if (manualSave) {
      toast.success("Saved");
    }
  } catch (err) {
    if (manualSave) {
      const message = this.getApiErrorMessage(err, "Failed to save report.");
      if (err?.status !== 400) {
        console.error(err);
      }
      toast.error(message);
    }
  } finally {
    this.saving = false;
  }
}


  setRouteToDmvFlag(result) {
    if (this.props.openWorkflowItemStep?.workflowItem?.report) {
      return new Promise<void>(async (resolve, reject) => {
        await Api.post(urls.SET_ROUTE_TO_DMV_FLAG, {
          ...this.props.openWorkflowItemStep.workflowItem.report,
          routeToDmv: result
        });
        await resolve();
      });
    }
  }

  UpdateKeywordsFromCheckers = () => {
    if (this.props.openWorkflowItemStep?.workflowItem?.report) {
      Api.post(urls.UPDATE_KEYWORDS_FROM_CHECKERS, {
        ...this.props.openWorkflowItemStep.workflowItem.report
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          toast.info("Successfully Updated Keywords");
        } else {
          toast.error("Failed to Update Keywords");
        }
      });
    }
  };

  openPaperReport() {
    const uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.GetPaperPdf
    );
    documentDownloadService
      .paperReport(
        uri,
        this.state.openWorkflowItemStep.workflowItem.report.paperReportId
      )
      .then(() => console.log("got")); //this.setState({ ...this.state, isGenerating: false }));
  }

  sendToManagementQueue = () => {
    try {
      this.handleSave(null, false, false, false, true);
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.state.openWorkflowItemStep.id
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: "/Checkers"
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  componentWillUnmount() {
    this.componentIsMounted = false;

    if (this.backgroundSave) {
      clearInterval(this.backgroundSave);
    }
    this.backgroundSave = null;
  }

  checkIsFormValid = (submission: any, formIsValid?: boolean) => {
    if (typeof formIsValid === 'boolean') {
      this.setState({ formIsValid });
      return;
    }

    if (this.checkersForm && typeof this.checkersForm.isFormValid === 'function') {
      this.setState({ formIsValid: this.checkersForm.isFormValid() });
    }
  };

  setValidationErrors = (validationErrors: Array<any>) => {
    this.setState({ validationErrors });
  };

  public render() {
    const allButtons = (
      <React.Fragment>
        <div className="completeAndStartNextButton">
          <Button
            variant="success"
            size="sm"
                    disabled={!this.state.formIsValid || this.state.isCompleting}
            onClick={(e) => this.handleComplete(e, true, true)}
          >
            Complete and Start Next Report
          </Button>
        </div>
        <div className="completeButton">
          <Button
            variant="success"
            size="sm"
                    disabled={!this.state.formIsValid || this.state.isCompleting}
            onClick={(e) => this.handleComplete(e, false, true)}
          >
            Complete
          </Button>
        </div>
        <div className="saveReportButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleSave(e, false, false, false, true)}
          >
            Save Report
          </Button>
        </div>
      </React.Fragment>
    );

    return (
      <div>
        <Row>
          <Col>
            <div className="workZoneCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Work Zone"
                  disabled={this.state.workZoneDisabled}
                  checked={this.state.workZoneCheckbox}
                  onChange={this.setWorkZoneCheckbox}
                />
              </Form.Group>
            </div>
            <div className="spdCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="State Property Damage"
                  checked={this.state.spdCheckbox}
                  onChange={this.setSpdCheckbox}
                />
              </Form.Group>
            </div>
          </Col>
          <Col className="justify-content-end">
            {" "}
            <NotificationTemplateSelector
              optionId={optionIds.checkerOptionId}
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
            />
          </Col>
          <Col xs={2} className="justify-content-end">
            <CommentsButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right"
              placement="left"
            />
            <CorrespondenceButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              className="pull-right mr-10"
            />
          </Col>
        </Row>
        <InfoButtonBar
          report={this.state.openWorkflowItemStep.workflowItem.report}
          handleOpenPdf={this.handleOpenPdf}
          sendToManagementQueue={this.sendToManagementQueue}
          createFrontSheetButton={
            <CreateFrontSheetButton
              reportId={this.state.openWorkflowItemStep.workflowItem.reportId}
              onBeforeClick={() =>
                this.handleSave(null, false, false, false, true)
              }
              className="openReportPdfButton"
            />
          }
        />
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        {this.state.data && Object.keys(this.state.data).length > 0 && (
          <DataEntryForm
            key={this.state.openWorkflowItemStep.id}
            data={this.state.data}
            injectToSidebar={allButtons}
            ref={(el) => (this.checkersForm = el)}
            onChange={this.checkIsFormValid}
            setFormErrors={this.setValidationErrors}
            formId={this.state.openWorkflowItemStep.workflowStep.formIoFormId}
          />
        )}
        {!this.state.data && <strong>Loading Form...</strong>}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep: state.CheckersQueue.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  saveCheckers,
  loadImage,
  getFrontSheet,
  showLoadingWithMessage
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Checkers)
);
